import { Component, Inject, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { WorkOrder } from "../../model";


@Component({
    selector: 'add-to-work-order-dialog',
    template: require('./add-to-work-order-dialog.component.html')
})
export class AddToWorkOrderDialogComponent {

    workOrders: WorkOrder[];

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) private dialogRef: MatDialogRef<AddToWorkOrderDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) { this.workOrders = data.workOrders; }

    createWorkOrder(): void {
        this.dialogRef.close({ new: true });
    }

    selectWorkOrder(workOrder: WorkOrder): void {
        this.dialogRef.close({ new: false, workOrder: workOrder });
    }
}